// helpers/fileDialog.ts
import { applyTransforms } from '@/utils/formTransforms';

export async function openFileDialog(floatFormStore: any, {
  label = 'Archivo',
  fields,
  formWidth = 800,
}: {
  label?: string;
  fields: any[];
  formWidth?: number;
}) {
  const formData = await floatFormStore.openFormWithPromise({
    component: 'EvidenceForm',
    formTitle: `Adjunta ${label}`,
    formWidth,
    props: { fields, formTitle: `Adjunta ${label}` },
  });
  return applyTransforms(fields, formData);
}
